import { createFileRoute } from '@tanstack/react-router'
import { AIModelsSettingsPage } from '../../../components/ai-models/AIModelsSettingsPage'

export const Route = createFileRoute('/$org/settings/ai-models')({
    component: AIModelsRoute,
})

// Which declared AI provider and model run the organization's data extraction
// (spec 2026-10-10-01). Readable by every member, writable by platform admins.
function AIModelsRoute() {
    const { org } = Route.useParams()
    return <AIModelsSettingsPage org={org} />
}
